import { ReactNode } from 'react';

import { CircularProgress, styled, Tooltip } from '@mui/material';

import BasicButton from './button/basic-button/basic-button';

interface TooltipItemProps {
  title: string;
  subtitle?: string;
  disabled?: boolean;
  loading?: boolean;
  icon: ReactNode;
  onClick: () => void;
}

const StyledIconButton = styled(BasicButton)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
`;

export const IconButtonWithTooltip = ({
  title,
  subtitle,
  disabled,
  loading,
  icon,
  onClick,
}: TooltipItemProps) => {
  return (
    <Tooltip
      enterTouchDelay={0}
      title={
        <div>
          <div>{title}</div>
          <div>{subtitle}</div>
        </div>
      }
    >
      <span>
        <StyledIconButton
          size="small"
          color="inherit"
          disabled={disabled}
          onClick={onClick}
        >
          {loading ? <CircularProgress size={20} /> : icon}
        </StyledIconButton>
      </span>
    </Tooltip>
  );
};
